module.exports = __webpack_public_path__ + "img/3.615abb73.jpg";